import {Component, OnInit, ViewChild, ChangeDetectorRef} from '@angular/core';
import {StsTenantService} from '../../../services/sts-tenant.service';
import {ActivatedRoute, Router} from '@angular/router';
import {StsHttpService} from '../../../services/sts-http.service';
import {StsNotification} from '../../../models/sts-notification.model';
import {StsNotificationType} from '../../../models/sts-notification-type';
import {StsErrorResponse} from '../../../models/sts-error-response';
import {StsButtonComponent} from 'app/components/common/sts-button/sts-button.component';

@Component({
  selector: 'app-account-forgot-password-email',
  templateUrl: './account-forgot-password-email.component.html',
  styleUrls: ['./account-forgot-password-email.component.scss']
})
export class AccountForgotPasswordEmailComponent implements OnInit {

  public notSentYet = true;
  public errors: StsNotification[] = [];

  private userName: string;

  @ViewChild(StsButtonComponent) submitButton;

  constructor(private stsHttp: StsHttpService,
              private router: Router,
              private ref: ChangeDetectorRef,
              private tenantService: StsTenantService,
              private route: ActivatedRoute) { }

  ngOnInit() {
    this.tenantService.getTenantSource().subscribe(tenant => {
      this.route.params.subscribe(params => {
        if (params['username']) {
          this.userName = params['username'];
        }
        this.sendRecoveryEmail();
      });
    });
  }


  private switchToQuestions() {
    if (this.userName) {
      let url = '/account/forgot-password/questions/' + this.userName;
      this.router.navigateByUrl(url);
    } else {
      this.guardAgainstNoUniqueId();
    }
  }

  private guardAgainstNoUniqueId() {
    this.errors = [];
    let e = new StsNotification();
    e.level = StsNotificationType.Error;
    e.description = 'unexpected error';
    e.code = 'generic-error';
    this.errors.push(e);
  }

  sendRecoveryEmail() {
    this.submitButton.onSubmit();
    this.errors = [];

    this.stsHttp.post('/api/users/send/me/email/for/reset/password?UserName=' + this.userName, {}).subscribe(
      (a: any) => {
        console.log(a);
        this.submitButton.onSubmitFinished();
        let msg = new StsNotification();
        if (a.success) {
          this.notSentYet = false;
          msg.code = 'sts-email-sent';
          msg.description = 'An email was sent to you with the link to reset your password';
          msg.level = StsNotificationType.Success;
          this.errors.push(msg);
        } else {
          msg.code = a['status'] ? 'sts-' + a['status'] : a['sts-code'];
          msg.description = a.message;
          msg.level = StsNotificationType.Error;
          this.errors.push(msg);
        }
        this.submitButton.onSubmitFinished();
      },
      errorRes => {
        this.submitButton.onSubmitFinished();
        errorRes = this.mapError(errorRes);
        this.handleError(errorRes);
        this.ref.detectChanges();
      });
  }


  private handleError(data) {

    let err = new StsNotification();
    if (data.error && data.error.errors && data.error.errors.length) {
      for (let i = 0; i < data.error.errors.length; i++) {
        let tmp =  data.error.errors[i];
        err = new StsNotification();
        err.code = 'sts-' + tmp['errorCode'].replace(/_/ig, '-').toLowerCase();
        err.description = tmp['explanation'];
        err.level = StsNotificationType.Error;
        this.errors.push(err);
      }
    } else {
      err.code = data.stsCode || 'sts-reset-pass-message';
      err.description = data.message || data.stsCode || 'Error';
      err.level = StsNotificationType.Error;
      this.errors.push(err);
    }
  }

  private mapError(data): StsErrorResponse {
    let response = new StsErrorResponse();
    response.message = data.message;
    response.status = data.status;
    response.stsCode = data['sts-code'];
    response.error = data.error;
    return response;
  }

}
